<template>
    <div class="container">
        <Nav></Nav>
        <div style="width:100%; height:70px;"></div>
        <NewsTop></NewsTop>
        <Row bgColor="#f5f6f8">
            <div class="pos2">
                <ul class="tab">
                    <li :class="tabIdx == 1 ? 'active' : ''" @click="TabHandle(1)">集团动态</li>
                    <li :class="tabIdx == 0 ? 'active' : ''" @click="TabHandle(0)">行业洞察</li>
                </ul>
                <ul class="list" v-show="tabIdx == 0">
                    <li v-for="(item, idx) in news[0].data" :key="item.id">
                        <template v-if="idx % 2 == 0">
                            <div class="cover">
                                <img :src="resourceBaseUrl + item.cover + '?x-oss-process=image/resize,m_fill,w_600,h_255'" />
                            </div>
                            <div class="desc">
                                <h2>{{ item.title }}</h2>
                                <p v-html="item.desc"></p>
                                <router-link class="pc-blue-button pc-more" :to="'/news/detail?id=' + item.id">MORE</router-link>
                                <!-- <section class="pc-blue-button pc-more" @click="$router.push('/about')">MORE</section> -->
                            </div>
                        </template>
                        <template v-else>
                            <div class="desc">
                                <h2>{{ item.title }}</h2>
                                <p v-html="item.desc"></p>
                                <router-link class="pc-blue-button pc-more" :to="'/news/detail?id=' + item.id">MORE</router-link>
                            </div>
                            <div class="cover">
                                <img :src="resourceBaseUrl + item.cover + '?x-oss-process=image/resize,m_fill,w_600,h_255'" />
                            </div>
                        </template>
                    </li>
                </ul>
                <ul class="list" v-show="tabIdx == 1">
                    <li v-for="(item, idx) in news[1].data" :key="item.id">
                        <template v-if="idx % 2 == 0">
                            <div class="cover">
                                <img :src="resourceBaseUrl + item.cover + '?x-oss-process=image/resize,m_fill,w_600,h_255'" />
                            </div>
                            <div class="desc">
                                <h2>{{ item.title }}</h2>
                                <p v-html="item.desc"></p>
                                <router-link class="pc-blue-button pc-more" :to="'/news/detail?id=' + item.id">MORE</router-link>
                            </div>
                        </template>
                        <template v-else>
                            <div class="desc">
                                <h2>{{ item.title }}</h2>
                                <p v-html="item.desc"></p>
                                <router-link class="pc-blue-button pc-more" :to="'/news/detail?id=' + item.id">MORE</router-link>
                            </div>
                            <div class="cover">
                                <img :src="resourceBaseUrl + item.cover + '?x-oss-process=image/resize,m_fill,w_600,h_255'" />
                            </div>
                        </template>
                    </li>
                </ul>
                <div class="pager">
                    <Pager v-show="tabIdx == 0" :pageSize="5" :pageNumber="news[0].page" :totalCount="news[0].total" @changePage="OnChangePageHandle"></Pager>
                    <Pager v-show="tabIdx == 1" :pageSize="5" :pageNumber="news[1].page" :totalCount="news[1].total" @changePage="OnChangePageHandle"></Pager>
                </div>
            </div>
        </Row>
        <Footer></Footer>
    </div>
</template>
<script>
import Nav from "@/components/pc/nav.vue";
import Footer from "@/components/pc/footer.vue";
import settings from "@/settings";
import Row from "@/components/pc/Row.vue";
import Pager from "@/components/pc/Pager.vue";
import NewsTop from "./NewsTop.vue";
export default {
    name: "pc-news",
    components: { Nav, Footer, Row, Pager, NewsTop },
    data() {
        return {
            loading: false,
            resourceBaseUrl: settings.resourceBaseUrl,
            news: [
                {
                    page: 0,
                    pages: 0,
                    total: 0,
                    data: [],
                },
                { page: 0, pages: 0, total: 0, data: [] },
            ],
            page: 0,
            ended: false,
            tabIdx: 1,
        };
    },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.loadData();
    },

    activated() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        if (this.$route.query.t) {
            this.$nextTick(() => {
                this.TabHandle(parseInt(this.$route.query.t));
            });
        }
        // console.log("activated");
        // if (this.$route.query.refresh) {
        //     console.log("refresh");
        //     this.$vnode.parent.componentInstance.cache = [];
        //     this.$router.push("/news");
        //     console.log("beforeRouteEnter", this.$vnode.parent.componentInstance.cache);
        // }
    },

    methods: {
        OnChangePageHandle(e) {
            this.loadData(e.page);
        },
        TabHandle(idx) {
            this.tabIdx = idx;
            this.loadData(1);
        },

        loadData(page) {
            // this.$showLoading("加载中...");
            this.$http.get(`/api/news/list?type=${this.tabIdx + 1}&pageSize=5&page=${page ? page : this.news[this.tabIdx].page + 1}`).then((res) => {
                this.news[this.tabIdx].page = page ? page : this.news[this.tabIdx].page + 1;
                this.news[this.tabIdx].pages = parseInt(res.data.totalPage);
                this.news[this.tabIdx].total = parseInt(res.data.totalCount);
                this.news[this.tabIdx].data = res.data.contents;
                this.$forceUpdate();
            });
        },
    },
};
</script>
<style scoped>
/* @import url("../../../common/css/pc.css"); */
@import url("../../../common/css/icon.css");

.list {
    width: 100%;
}

.pos2 {
    width: 100%;
    text-align: left;
}

.tab li:first-child {
    border-right: 1px #000 solid;
    padding-right: 20px;
    margin-right: 20px;
}
.tab .active {
    color: #222;
}

@media only screen and (max-width: 2048px) {
    .pager {
        margin-top: calc(100px * var(--scale));
        display: inline-block;
        width: 100%;
        margin-bottom: 150px;
    }
    .list li {
        display: flex;
        align-items: center;
        margin-bottom: calc(103px * var(--scale));
    }
    .list li .cover {
        width: calc(600px * var(--scale));
        height: calc(300px * var(--scale));
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 15px;
    }

    .list li .desc {
        flex: 1;
        height: calc(300px * var(--scale));
        background: #fff;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .list li .desc h2 {
        font-size: 2.2rem;
        margin: 20px 30px 0 30px;
        font-weight: normal;
    }
    .list li .desc p {
        font-size: 1.5rem;
        margin: 20px 30px;
        font-weight: normal;
        line-height: 2.5rem;
    }
    .list li:nth-child(odd) .desc a {
        position: absolute;
        right: 15px;
        bottom: -20px;
        /* height: 40px; */
        cursor: pointer;
    }
    .list li:nth-child(even) .desc a {
        position: absolute;
        left: 15px;
        bottom: -20px;
        /* height: 40px; */
        cursor: pointer;
    }
    .tab {
        color: #9a9a9a;
        font-size: 2.8rem;
        display: inline-flex;
        margin: 80px 0 60px 0;
    }
    .tab li {
        cursor: pointer;
        line-height: 2.8rem;
    }
}

@media only screen and (min-width: 2049px) {
    .pager {
        margin-top: 100px;
        display: inline-block;
        width: 100%;
        margin-bottom: 150px;
    }
    .list li {
        display: flex;
        align-items: center;
        margin-bottom: 103px;
    }
    .list li .cover {
        width: 600px;
        height: 300px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 15px;
    }
    .list li .desc {
        flex: 1;
        height: 300px;
        background: #fff;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .list li .desc h2 {
        font-size: 2.2rem;
        margin: 20px 30px;
        font-weight: normal;
    }
    .list li .desc p {
        font-size: 1.5rem;
        margin: 20px 30px;
        font-weight: normal;
        line-height: 3rem;
    }
    .list li:nth-child(odd) .desc a {
        position: absolute;
        right: 15px;
        bottom: -20px;
        /* height: 50px; */
        cursor: pointer;
    }
    .list li:nth-child(even) .desc a {
        position: absolute;
        left: 15px;
        bottom: -20px;
        /* height: 50px; */
        cursor: pointer;
    }
    .tab {
        color: #9a9a9a;
        font-size: 3rem;
        display: inline-flex;
        margin: 80px 0 60px 0;
    }
    .tab li {
        cursor: pointer;
        line-height: 3rem;
    }
}
</style>
